import deleteData from "../services/deleteData";
import fetchData from "../services/fetchData";
import patchData from "../services/patchData";
import postData from "../services/postData";

const handleFetchRequests = async ({ page, limit, status }: any) => {
  const uri = `v1/requests?page=${page}&limit=${limit}&status=${status}`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchRequest = async ({ _id }: any) => {
  const uri = `v1/requests/${_id}`;
  const response = fetchData({ uri });
  return response;
};

const handleAcceptRequest = async ({ _id, data }: any) => {
  const uri = `v1/requests/${_id}/accept`;
  const response = patchData({ uri, data });
  return response;
};

const handleRejectRequest = async ({ _id, data }: any) => {
  const uri = `v1/requests/${_id}/reject`;
  const response = patchData({ uri, data });
  return response;
};

const handleExportRequests = async () => {
  const uri = `v1/requests/export/data`;
  const response = fetchData({ uri });
  return response;
};

const handleFetchRequestsCount = async ({ status }: any) => {
  const uri = `v1/requests/count/all?status=${status}`;
  const response = fetchData({ uri });
  return response;
};

const handleCreateRequest = async (data: any) => {
  const uri = `v1/requests`;
  const response = postData({ data, uri });
  return response;
};

const handleUpdateRequest = async ({ _id, data }: any) => {
  const uri = `v1/requests/${_id}`;
  const response = patchData({ data, uri });
  return response;
};

const handleDeleteRequest = async (data: any) => {
  const uri = `v1/requests`;
  const response = deleteData({ data, uri });
  return response;
};

export {
  handleFetchRequests,
  handleFetchRequest,
  handleAcceptRequest,
  handleRejectRequest,
  handleExportRequests,
  handleCreateRequest,
  handleUpdateRequest,
  handleDeleteRequest,
  handleFetchRequestsCount,
};
